import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { Box, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Divider from "@mui/material/Divider";
import { UserContext } from "App";
import { useContext, useEffect, useState } from "react";
import { emit } from "react-native-react-bridge/lib/web";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getLoyaltyDetails,
  getOrderDetails,
  getUserFromUidx,
  newCartCreationAfterAdjusting,
  returnItemDetails,
  payOrderSplit,
  getPaymentStatus,
  getToken,
} from "../../../../config/Services";
import { convertToLocalDateTime } from "../all-products/Middleware/commonUtils";
import StyledButton from "../all-products/components/custom/StyledButton";
import { addcoupon } from "../all-products/redux/Actions/couponActions";
import { orderDetailsFilter } from "../all-products/redux/Actions/paginationActions";
import {
  getDeviceType,
  getMobilePos,
  getOrderStatus,
} from "../all-products/redux/Reducers/paginationReducer";
import { getmangerPin, getmangeruidx } from "../all-products/redux/Reducers/sessionReducer";
import { useSnackbar } from "../hooks/SnackbarProvider";
import useAuthModal from "../hooks/useAuthModal";
import useGetDevice from "../hooks/useGetDevice";
import usePrint from "../hooks/usePrint";
import { GstSlabs } from "./components/gstSlab";
import { RecordPaymentModal } from "./components/recordPayemetModal";
import OrderDetailsNew from "./newOrderDetails";
import "./orders.css";
import { getFromLocalStorage } from "../../../../utils/localStorageHelpers";
import { PosCustomButton } from "../../../../customComponents/PosCustomButton/PosCustomButton";
import PosCustomIcon from "../../../../customComponents/PosCustomIcon/PosCustomIcon";
import { ArrowLeftIcon, ArrowPathIcon } from "@heroicons/react/24/outline";
import { right } from "@popperjs/core";
import swiggy from "../../../../assets/images/swiggy.png";
import zomato from "../../../../assets/images/zomato.png";
import uberEats from "../../../../assets/images/uberEats.jpg";
import dineIn from "../../../../assets/images/dineIn.jpg";
import whatsapp from "../../../../assets/images/whatsapp.png";
import PaymentModal from "../all-products/components/twoWaykeyboardPaymentPage/components/paymentModal";
import ManagerPinVerifyModal from "../all-products/components/managerPinVerify";
import { hasPosManagerRole } from "../../../../services/rbacConfig";
import cashIcon from "../../../../assets/images/coin-icon.png";
import cardIcon from "../../../../assets/images/mastercard-icon.png";
import upiIcon from "../../../../assets/images/upi-icon.png";
import offlineImg from "../../../../assets/images/offline-icon.png";
import splitImg from "../../../../assets/images/split-icon.png";
import cashNew from "../../../../assets/images/cash-new.png";
import cashNewSelected from "../../../../assets/images/cash-new-selected.png";
import cardNew from "../../../../assets/images/card-new.png";
import cardNewSelected from "../../../../assets/images/card-new-selected.png";
import upiNew from "../../../../assets/images/upi-new.png";
import upiNewSelected from "../../../../assets/images/upi-new-selected.png";
import splitNew from "../../../../assets/images/split-new.png";
import splitNewSelected from "../../../../assets/images/split-new-selected.png";
import creditNew from "../../../../assets/images/credit-new.png";
import creditNewSelected from "../../../../assets/images/credit-new-selected.png";

export const OrderDetailsPage = ({
  orderId,
  setUpdate,
  update,
  setState,
  setCustomerPage,
  state,
  orderValue,
  type,
  returnId,
  handleBack,
  forcePickPrinter = false,
}) => {
  const showSnackbar = useSnackbar();
  const isMobile = useGetDevice();
  const { renderAuthModal, openAuthModal } = useAuthModal();
  const { startPrint, isPrinting, openDrawer } = usePrint();
  const [noGst, setNoGst] = useState([]);
  const [orderData, setOrderData] = useState({});
  const [gst1slab, setGst1slab] = useState([]);
  const [gst2slab, setGst2slab] = useState([]);
  const [gst5slab, setGst5slab] = useState([]);
  const [gst6slab, setGst6slab] = useState([]);
  const [gst9slab, setGst9slab] = useState([]);
  const [gst14slab, setGst14slab] = useState([]);
  const [freeProducts, setFreeProducts] = useState([]);
  const [orderDetails, setOrderDetails] = useState({});
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [baseOrderResponse, setBaseOrderResponse] = useState({});
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState("");
  const [gstBreakupDetails, setGstBreakupDetails] = useState([]);
  const [baseDetails, setBaseDetails] = useState({});
  const [returnDetails, setReturnDetails] = useState({});
  const navigate = useNavigate();
  const { cartItems, setCartItems } = useContext(UserContext);
  const { subTotal, setSubTotal } = useContext(UserContext);
  const { total, setTotal } = useContext(UserContext);
  const { cgst, setCgst } = useContext(UserContext);
  const { sgst, setSgst, setCess, cess } = useContext(UserContext);
  const [loggedUser, setLoggedUser] = useState("");
  const isMobilePos = useSelector(getMobilePos);
  const dispatch = useDispatch();
  const deviceType = useSelector(getDeviceType);
  const managerNumber = useSelector(getmangeruidx);
  const mangerPin = useSelector(getmangerPin);
  const [isVisible, setVisible] = useState(false);
  const [loader, setLoader] = useState(false);
  const [openRecordPayment, setOpenRecordPayment] = useState(false);

  // Payment modal states
  const [openPayModal, setOpenPayModal] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("CASH");
  const [enterAmount, setEnterAmount] = useState("");
  const [paymentLoader, setpaymentLoader] = useState(false);
  const [paymentFailed, setPaymentFailed] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [paymentLoadingModal, setPaymentLoadingModal] = useState(false);
  const [paymentCancel, setPaymentCancel] = useState(false);
  const [amountPaid, setAmountPaid] = useState("0");
  const [amountDue, setAmountDue] = useState("0");
  const [partialStatus, setPartailStatus] = useState(false);
  const [splitActive, setSplitActive] = useState(false);
  const [singleOrderoffline, setSingleOrderOffline] = useState(false);
  const [newTransId, setNewTransId] = useState(false);
  const [paymentMode, setPaymentMode] = useState("");
  const [modalLoader, setModalLoader] = useState(false);
  const [payLoader, setPayLoader] = useState(false);
  const [cashChange, setCashChange] = useState(false);
  const [functionCalled, setFunctionCalled] = useState(false);
  const [cardFunctionCalled, setCardFunctionCalled] = useState(false);
  const [splitFunctionCalled, setSplitFunctionCalled] = useState(false);
  const [manual, setManaul] = useState(false);
  const [transCode, setTransCode] = useState("");
  const [approveloader, setApproveLoader] = useState(false);
  const [cancelLoader, setCancelLoader] = useState(false);
  /* ── Forced-offline payment (from order details Pay button) ── */
  const [forceOfflineMode, setForceOfflineMode] = useState(false);
  const [showManagerPinGate, setShowManagerPinGate] = useState(false);
  // const storeMode = localStorage.getItem("storeMode");
  const storeMode = localStorage.getItem("cartStoreMode");
  const machineId = localStorage.getItem("machineId");
  const licenseName = localStorage.getItem("licenseName");
  const failedImgWarning = "https://icon-library.net/images/failed-icon/failed-icon-8.jpg";
  const cancelGif =
    "https://cdn0.iconfinder.com/data/icons/banking-156/60/cancel__delete__payment__card__credit-512.png";

  const branchSubType = localStorage.getItem("branchSubType");
  const retailType = localStorage.getItem("retailType");
  const retailUserDetails = JSON.parse(localStorage.getItem("retailUserDetails") || "{}");
  const toggle = () => {
    setVisible(!isVisible);
  };
  const orderStatus = useSelector(getOrderStatus);
  const [paymnetBreakupDetails, setPaymnetBreakupDetails] = useState([]);
  const [returnPaymnetBreakupDetails, setReturnPaymnetBreakupDetails] = useState([]);
  const mode = localStorage.getItem("mode");

  const [billTabValue, setBillTabValue] = useState("0");
  const [loyaltyData, setLoyaltyData] = useState({});
  const orgId = localStorage.getItem("orgId");
  const locId = getFromLocalStorage("locId");
  const [orderStat, setOrderStat] = useState("");

  const { pathname } = useLocation();
  const getAppliedOrderDiscount = (billingDetails) => Number(billingDetails?.appliedDiscount ?? 0);
  const getTotalDiscount = (billingDetails) => Number(billingDetails?.totalDiscount ?? 0);

  const fetchData = async (response) => {
    const data = response?.data?.data;
    setOrderData(response?.data);
    setBaseOrderResponse(data?.orderBillingDetails || data?.returnBillingDetails);
    setBaseDetails(data?.baseOrderResponse || data?.baseReturnResponse);
    setDate(
      convertToLocalDateTime(
        data?.baseOrderResponse?.createdAt || data?.baseReturnResponse?.createdAt
      )
    );
    setGstBreakupDetails(data?.gstBreakupDetails);
    type !== "returns"
      ? setPaymnetBreakupDetails(response?.data?.data?.orderBillingDetails?.payments)
      : setReturnPaymnetBreakupDetails(response?.data?.data?.returnBillingDetails);
    setOrderDetails(data?.orderBillingDetails || data?.returnBillingDetails);
    setReturnDetails(data?.returnDetails);
    setFreeProducts(data?.freeProducts);
    setOrderStat(data?.baseOrderResponse?.orderStatus || data?.baseReturnResponse?.orderStatus);
    setTotalQuantity(
      (data?.baseOrderResponse?.orderItemList || data?.baseReturnResponse?.returnedItems || [])
        ?.map((item) => item.quantity)
        .reduce((a, b) => a + b, 0)
    );
    const gstWiseOrderItems = data?.gstWiseOrderItems || {};
    setNoGst(gstWiseOrderItems["No Gst slab"] || []);
    setGst1slab(gstWiseOrderItems["1.5 cgst and 1.5 sgst slab"] || []);
    setGst2slab(gstWiseOrderItems["2.5 cgst and 2.5 sgst slab"] || []);
    setGst5slab(gstWiseOrderItems["5 cgst and 5 sgst slab"] || []);
    setGst6slab(gstWiseOrderItems["6 cgst and 6 sgst slab"] || []);
    setGst9slab(gstWiseOrderItems["9 cgst and 9 sgst slab"] || []);
    setGst14slab(gstWiseOrderItems["14 cgst and 14 sgst slab"] || []);

    const userId =
      data?.baseOrderResponse?.loggedInUserId || data?.baseReturnResponse?.loggedInUserId;
    if (userId) {
      const userResponse = await getUserFromUidx(userId);
      setLoggedUser(userResponse.data.data.firstName + " " + userResponse.data.data.secondName);
    }

    const cusId = data?.baseOrderResponse?.customerId || data?.baseReturnResponse?.customerId;
    if (cusId) {
      const loyaltyResponse = await getLoyaltyDetails(orgId, cusId);
      setLoyaltyData(loyaltyResponse?.data?.data?.data);
    }
  };

  useEffect(() => {
    setLoading(true);
    const fetchDetails = async () => {
      try {
        if (type !== "returns") {
          const response = await getOrderDetails(orderId, locId);
          await fetchData(response);
        } else {
          const response = await returnItemDetails(returnId, orderId);
          await fetchData(response);
        }
      } catch (error) {
        console.error("Failed to fetch data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, [type, orderId, returnId, orgId]);

  const handlePrint = async () => {
    if (isMobilePos) {
      emit({
        type: "order",
        data: orderData,
      });
      return;
    }
    startPrint({
      orderId,
      reprint: true,
      printType: type == "returns" ? "credit-note" : "invoice",
      returnId,
      forcePick: forcePickPrinter,
    });
  };

  var val = localStorage.getItem("retailUserDetails");

  const adjustOrder = () => {
    setLoader(true);
    newCartCreationAfterAdjusting(cartId, orderId)
      .then((response) => {
        localStorage.setItem("CartId", response?.data?.data?.cartId);
        localStorage.setItem("OrderId", response?.data?.data?.orderId);
        const existingCustomerDetails = JSON.parse(localStorage.getItem("customer_details"));
        const updatedCustomerDetails = {
          ...existingCustomerDetails,
          name: response?.data?.data?.userName,
          mobileNumber: response?.data?.data?.mobileNo,
          uidx: response?.data?.data?.userId,
        };
        localStorage.setItem("customer_details", JSON.stringify(updatedCustomerDetails));
        isMobilePos &&
          emit({
            type: "localData",
            data: {
              CartId: response?.data?.data?.cartId,
              OrderId: response?.data?.data?.orderId,
              customer_details: updatedCustomerDetails,
            },
          });
        setCartItems(cartItems);
        setCgst(cgst);
        setSgst(sgst);
        setSubTotal(subTotal);
        setTotal(total);
        setCess(cess);
        setUpdate(!update);
        dispatch(addcoupon("-----"));
        navigate(mode === "KEYPAD" ? "/grocery/cart" : "/products/all-products", {
          state: {
            isOrderEditing: true,
          },
        });
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const handleback = () => {
    dispatch(orderDetailsFilter(false));
  };

  const closeModal = () => {
    setState(false);
    setCustomerPage(false);
    dispatch(orderDetailsFilter(false));
  };

  useEffect(() => {
    if (!managerNumber || !mangerPin || !state) return;
    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        handleEdit();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [managerNumber, mangerPin, state]);

  const handleCloseRecordPayment = () => {
    setOpenRecordPayment(false);
  };

  const handleEdit = () => {
    openAuthModal(() => adjustOrder(baseDetails.cartId, orderId));
  };

  // Payment related functions
  const handleOpenPaymentModal = () => {
    const outstandingAmount = orderDetails?.grandTotal - (orderDetails?.amountPaid || 0);
    setAmountDue(outstandingAmount);
    setAmountPaid(orderDetails?.amountPaid || 0);
    setPartailStatus(true);

    const alreadyOffline = storeMode === "OFFLINE" || !machineId;

    if (alreadyOffline || hasPosManagerRole()) {
      /* Store is already offline, OR user has manager role — no PIN needed */
      setForceOfflineMode(true);
      setOpenPayModal(true);
    } else {
      /* Online store + non-manager — require manager PIN before proceeding */
      setShowManagerPinGate(true);
    }
  };

  const closePaymentModal = () => {
    setOpenPayModal(false);
    resetPaymentValues();
  };

  const resetPaymentValues = () => {
    setPaymentLoadingModal(false);
    setSingleOrderOffline(false);
    setSplitActive(false);
    setEnterAmount("");
    setPayLoader(false);
    setCashChange(false);
    setPartailStatus(false);
    setAmountPaid("");
    setPaymentMethod("CASH");
    setForceOfflineMode(false);
  };

  const handleSplitPayment = () => {
    setPaymentMethod("CASH");
    setSplitActive(true);
  };

  const handleOffline = () => {
    setSingleOrderOffline(true);
  };

  const handleManual = () => {
    setManaul(true);
  };

  const clrAmountFun = () => setEnterAmount("");

  const handlesplitInputChange = (e) => {
    const valueInput = e.target.value;
    setEnterAmount(valueInput);
  };

  const callPaymentStatus = (transId, currentRetry) => {
    let maxRetries = 95;
    let retry = currentRetry || 0;

    getPaymentStatus(transId)
      .then((res) => {
        if (
          res?.data?.data?.paymentResponseModel?.paymentStatus === "PAYMENT_INITIATED" &&
          retry < maxRetries
        ) {
          retry++;
          showSnackbar(res?.data?.data?.paymentResponseModel?.paymentStatus, "success");
          setPaymentLoadingModal(true);
          setpaymentLoader(true);
          setPaymentSuccess(false);
          setTimeout(() => callPaymentStatus(transId, retry), 2000 + retry);
          if (retry === maxRetries) {
            setPaymentFailed(true);
          }
        } else if (res?.data?.data?.paymentResponseModel?.paymentStatus === "COMPLETED") {
          showSnackbar(res?.data?.data?.paymentResponseModel?.paymentStatus, "success");
          setPaymentSuccess(true);
          setpaymentLoader(false);
          setTimeout(() => {
            closePaymentModal();
            // Refresh order details
            const fetchDetails = async () => {
              try {
                const response = await getOrderDetails(orderId, locId);
                await fetchData(response);
                setUpdate(!update);
              } catch (error) {
                console.error("Failed to fetch data:", error);
              }
            };
            fetchDetails();
          }, 2000);
        } else if (
          res?.data?.data?.paymentResponseModel?.paymentStatus === "PAYMENT_CANCELLED" ||
          res?.data?.data?.paymentResponseModel?.paymentStatus === "CANCELLED"
        ) {
          retry = maxRetries;
          setPaymentLoadingModal(false);
          setCancelLoader(false);
          setpaymentLoader(false);
          showSnackbar(res?.data?.data?.paymentResponseModel?.paymentStatus, "error");
        }
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
      });
  };

  const partialCompletePayment = () => {
    if (!orderId) {
      showSnackbar("Order ID is missing. Please try again.", "error");
      return;
    }

    if ((enterAmount === 0 || enterAmount === "" || enterAmount < 1) && splitActive) {
      showSnackbar("You need to pay atleast 1 Rupee to process this order", "error");
      return;
    }

    const sessionId = localStorage.getItem("sessionId");
    const licenseId = localStorage.getItem("licenseId");
    const uidx = retailUserDetails?.uidx;

    const change = (Number(enterAmount) - Number(amountDue)).toFixed(2);

    let payload = {
      orderId: orderId,
      ...(splitActive && { paymentType: "SPLIT" }),
      amount: splitActive || paymentMethod === "CASH" ? enterAmount : amountDue,
      paymentMethod: paymentMethod,
      paymentMode:
        forceOfflineMode || singleOrderoffline || storeMode === "OFFLINE" || !machineId
          ? "OFFLINE"
          : "ONLINE",
      licenseId: licenseId,
      sessionId: sessionId,
      loggedInUserId: uidx,
      machineCode: machineId,
      tender: enterAmount,
      balance: String(Math.abs(change)),
    };

    setModalLoader(true);

    payOrderSplit(payload)
      .then((res) => {
        setPaymentLoadingModal(true);
        if (res?.data?.data?.es === 1) {
          showSnackbar(res?.data?.data?.message, "error");
          setModalLoader(false);
          return;
        }

        if (res?.data?.data?.paymentStatus === "COMPLETED") {
          setPaymentFailed(false);
          setPaymentSuccess(true);
          setpaymentLoader(true);

          if (paymentMethod === "CASH") {
            openDrawer();
          }

          showSnackbar("Payment Success", "success");
          setTimeout(() => {
            closePaymentModal();
            // Refresh order details
            const fetchDetails = async () => {
              try {
                const response = await getOrderDetails(orderId, locId);
                await fetchData(response);
                setUpdate(!update);
              } catch (error) {
                console.error("Failed to fetch data:", error);
              }
            };
            fetchDetails();
          }, 2000);
        } else if (
          res?.data?.data?.paymentStatus === "PARTIALLY_PAID" ||
          res?.data?.data?.paymentStatus === "PAYMENT_PENDING" ||
          res?.data?.data?.paymentStatus === "PAYMENT_CANCELLED"
        ) {
          if ((paymentMethod === "CARD" || paymentMethod === "UPI") && storeMode === "ONLINE") {
            setPaymentLoadingModal(true);
            setNewTransId(res?.data?.data?.transactionCode);
            callPaymentStatus(res?.data?.data?.transactionCode);
          }
          setPaymentLoadingModal(false);
          setCashChange(true);
          showSnackbar(res?.data?.data?.paymentStatus, "success");
          setEnterAmount("");
          setAmountPaid(res?.data?.data?.amountPaid);
          setAmountDue(res?.data?.data?.amountToBePaid);
          setPayLoader(false);
          setModalLoader(false);
        } else {
          setPayLoader(false);
          setPaymentLoadingModal(false);
          setModalLoader(false);
        }
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
        setPayLoader(false);
        setCashChange(false);
        setModalLoader(false);
      });
  };

  const gstSlabData = [
    { title: "No Gst slab", item: noGst },
    { title: "1.5 cgst and 1.5 sgst slab", item: gst1slab },
    { title: "2.5 cgst and 2.5 sgst slab", item: gst2slab },
    { title: "5 cgst and 5 sgst slab", item: gst5slab },
    { title: "6 cgst and 6 sgst slab", item: gst6slab },
    { title: "9 cgst and 9 sgst slab", item: gst9slab },
    { title: "14 cgst and 14 sgst slab", item: gst14slab },
    { title: "Free Products", item: freeProducts },
  ];

  const formatSalesChannel = (channel) => {
    if (!channel) return "";

    const channelMap = {
      SWIGGY_ORDER: { label: "Swiggy", color: "#FC8019", logo: swiggy },
      ZOMATO_ORDER: { label: "Zomato", color: "#E23744", logo: zomato },
      UBER_EATS: { label: "Dine In", color: "#4CAF50", logo: uberEats },
      RESTAURANT_ORDER: { label: "Restaurant Order", color: "#FF9800", logo: dineIn },
      DELIVERY: { label: "Delivery", color: "#2196F3" },
      POS: { label: "POS", color: "#9C27B0" },
      ONLINE: { label: "Online", color: "#00BCD4" },
      WHATSAPP_ORDER: { label: "Whatsapp", color: "#4CAF50", logo: whatsapp },
    };

    if (channelMap[channel]) {
      return channelMap[channel];
    }

    // Default formatting for unknown channels
    const formatted = channel.replace(/_/g, " ").toLowerCase();
    return {
      label: formatted.charAt(0).toUpperCase() + formatted.slice(1),
      color: "#757575",
    };
  };

  const salesChannelInfo =
    type === "returns"
      ? formatSalesChannel(orderData?.data?.baseReturnResponse?.salesChannel)
      : formatSalesChannel(orderData?.data?.baseOrderResponse?.orderType);

  const showPayButton = () => {
    if (retailType === "RESTAURANT" && branchSubType === "FINE_DINE") {
      if (
        baseDetails?.orderStatus === "PARTIALLY_PAID" ||
        (baseDetails?.orderStatus === "PAYMENT_PENDING" &&
          orderDetails?.paymentMethod !== "CREDIT_NOTE")
      ) {
        return true;
      }
    } else {
      if (baseDetails?.orderStatus === "CREATED" || baseDetails?.orderStatus === "PARTIALLY_PAID") {
        return true;
      }
    }
    return false;
  };

  const isShowPayButton = showPayButton();
  const appliedOrderDiscount = Number(orderData?.data?.orderBillingDetails?.totalDiscount ?? 0);

  // handle reprint kot
  const handleReprintKot = async () => {
    if (isMobilePos) {
      emit({
        type: "order",
        data: orderData,
      });
      return;
    }

    startPrint({
      orderId,
      reprint: true,
      skipBill: true, // skip the bill/invoice
      skipKot: false,
    });
  };

  return (
    <>
      {renderAuthModal()}
      <Box className="receipt-wrapper-box">
        {loading ? (
          <Box className="loader-order-details-page">
            <CircularProgress />
          </Box>
        ) : (
          <div className="order-details-container-new">
            {/* <Box className="order-details-btns-main">
              <Box onClick={closeModal}>
                <ArrowBackIosNewIcon sx={{ display: isMobile ? "block" : "none" }} />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <Box>
                  <StyledButton
                    disabled={billTabValue === "0"}
                    size="medium"
                    onClick={() => setBillTabValue("0")}
                  >
                    {type === "returns" ? "Return Details" : "Order Details"}
                  </StyledButton>
                </Box>
                {type !== "returns" && (
                  <Box>
                    <StyledButton size="medium" onClick={() => setBillTabValue("1")}>
                      View Bill
                    </StyledButton>
                  </Box>
                )}
                <PosCustomButton title={"back"} onClickFunction={handleBack}/>
                {baseDetails?.orderStatus == "CANCELLED" ||
                baseDetails?.orderStatus == "PAYMENT_CANCELLED" ? null : (
                  <>
                    {orderValue?.value === "App orders" &&
                      baseDetails?.orderStatus === "CREATED" && (
                        <Box>
                          <StyledButton size="medium" onClick={() => setOpenRecordPayment(true)}>
                            Record Payment
                          </StyledButton>
                        </Box>
                      )}
                    {baseDetails?.orderStatus === "PAID" && (
                      <Box>
                        <StyledButton size="medium" loading={isPrinting} onClick={handlePrint}>
                          Reprint
                        </StyledButton>
                      </Box>
                    )}
                  </>
                )}

                {!!orderStatus && (
                  <StyledButton size="medium" onClick={() => handleback()}>
                    back
                  </StyledButton>
                )}

                <RecordPaymentModal
                  openRecordPayment={openRecordPayment}
                  orderId={orderId}
                  handleCloseRecordPayment={handleCloseRecordPayment}
                  setState={setState}
                  setUpdate={setUpdate}
                  update={update}
                />
              </Box>
            </Box> */}
            <div className="orderDetailsButtonsContainer">
              <div className="orderDetailsButtonsContainerLeft">
                <PosCustomButton
                  variant="black-s"
                  title={<PosCustomIcon icon={<ArrowLeftIcon />} height={"20px"} width={"20px"} />}
                  radius="4px"
                  onClickFunction={handleBack}
                />

                <PosCustomButton
                  variant="blue-d"
                  title={type === "returns" ? "Return Details" : "Order Details"}
                  p={"10px 12px 10px 12px"}
                  border={true}
                  radius="4px"
                  disabled={billTabValue === "0"}
                  onClickFunction={() => setBillTabValue("0")}
                />

                {type !== "returns" && (
                  <PosCustomButton
                    variant="blue-d"
                    title={"View Bill"}
                    p={"10px 12px 10px 12px"}
                    border={true}
                    radius="4px"
                    onClickFunction={() => setBillTabValue("1")}
                  />
                )}
                {/* print kot button - ["RESTAURANT"] */}
                {retailType === "RESTAURANT" && (
                  <PosCustomButton
                    title="Reprint KOT"
                    variant="blue-d"
                    radius={"4px"}
                    disabled={false}
                    p={"10px 12px 10px 12px"}
                    iconOnRight={
                      <PosCustomIcon
                        icon={<ArrowPathIcon />}
                        height={"16px"}
                        width={"16px"}
                        color="#fff"
                      />
                    }
                    onClickFunction={() => handleReprintKot()}
                  />
                )}
              </div>
              <div className="orderDetailsButtonsContainerRight">
                {baseDetails?.orderStatus == "CANCELLED" ||
                baseDetails?.orderStatus == "PAYMENT_CANCELLED" ? null : (
                  <>
                    {/* {orderValue?.value === "App orders" &&
                      baseDetails?.orderStatus === "CREATED" && (
                        <Box>
                          <StyledButton size="medium" onClick={() => setOpenRecordPayment(true)}>
                            Record Payment
                          </StyledButton>
                        </Box>
                      )} */}

                    {/* here */}
                    {isShowPayButton && (
                      <PosCustomButton
                        variant="blue-d"
                        title={"Record Payment"}
                        p={"10px 12px 10px 12px"}
                        border={true}
                        radius="4px"
                        loading={modalLoader || payLoader}
                        disabled={modalLoader || payLoader}
                        onClickFunction={handleOpenPaymentModal}
                      />
                    )}

                    {/* {(baseDetails?.orderStatus === "PARTIALLY_PAID" ||
                      (baseDetails?.orderStatus === "PAYMENT_PENDING" &&
                        orderDetails?.paymentMethod !== "CREDIT_NOTE")) &&
                      retailType === "RESTAURANT" &&
                      branchSubType === "FINE_DINE" && (
                        <PosCustomButton
                          variant="blue-d"
                          title={"Pay"}
                          p={"10px 12px 10px 12px"}
                          border={true}
                          radius="4px"
                          loading={modalLoader || payLoader}
                          disabled={modalLoader || payLoader}
                          onClickFunction={handleOpenPaymentModal}
                        />
                      )} */}

                    {baseDetails?.orderStatus === "PAID" && (
                      <PosCustomButton
                        variant="blue-d"
                        title={"Reprint"}
                        p={"10px 12px 10px 12px"}
                        border={true}
                        radius="4px"
                        loading={isPrinting}
                        onClickFunction={handlePrint}
                      />
                    )}
                  </>
                )}
              </div>
            </div>
            {billTabValue === "0" && (
              <Box pt={6}>
                <Box className="order-details-bill-details">
                  {type !== "returns" ? (
                    <>
                      {baseDetails?.invoiceId ? (
                        <Box className="order-details-bill-no">
                          <Typography variant="p" fontSize="14px" fontWeight={600}>
                            Order Id :{" "}
                          </Typography>
                          <Typography variant="p" fontSize="14px" fontWeight={700}>
                            {baseDetails?.invoiceId}
                          </Typography>
                        </Box>
                      ) : (
                        <Box className="order-details-bill-no">
                          <Typography variant="p" fontSize="14px" fontWeight={600}>
                            Order Id :{" "}
                          </Typography>
                          <Typography variant="p" fontSize="14px" fontWeight={700}>
                            {baseDetails?.orderId}
                          </Typography>
                        </Box>
                      )}
                    </>
                  ) : (
                    <>
                      <Box className="order-details-bill-no">
                        <Typography variant="p" fontSize="14px" fontWeight={600}>
                          Bill No:{" "}
                        </Typography>
                        <Typography variant="p" fontSize="14px" fontWeight={700}>
                          {baseDetails?.invoiceId}
                        </Typography>
                      </Box>
                    </>
                  )}
                  <Box className="order-details-bill-no">
                    <Typography variant="p" fontSize="14px" fontWeight={600} textAlign={right}>
                      Bill Date
                    </Typography>
                    <Typography variant="p" fontSize="14px" fontWeight={700}>
                      {date.toLocaleString()}
                    </Typography>
                  </Box>
                </Box>
                {type === "returns" && (
                  <Box className="order-details-bill-details">
                    <Box className="order-details-bill-no">
                      <Typography variant="p" fontSize="14px" fontWeight={600}>
                        Return Id :{" "}
                      </Typography>
                      <Typography variant="p" fontSize="14px" fontWeight={700}>
                        {baseDetails?.returnId}
                      </Typography>
                    </Box>
                    <Box className="order-details-bill-no">
                      <Typography variant="p" fontSize="14px" fontWeight={600}>
                        Order Id :{" "}
                      </Typography>
                      <Typography variant="p" fontSize="14px" fontWeight={700}>
                        {baseDetails?.orderId}
                      </Typography>
                    </Box>
                  </Box>
                )}
                <Box className="order-details-bill-second">
                  <Box className="order-details-bill-no">
                    <Typography variant="p" fontSize="14px" fontWeight={600}>
                      Cashier :{" "}
                    </Typography>
                    <Typography variant="p" fontSize="14px" fontWeight={700}>
                      {retailType === "RESTAURANT" ? (
                        <>{baseDetails?.createdByName}</>
                      ) : (
                        <>{baseDetails?.createdBy}</>
                      )}
                    </Typography>
                  </Box>
                  <Box className="order-details-bill-no">
                    <Typography variant="p" fontSize="14px" fontWeight={600} textAlign={right}>
                      {type == "returns" ? "Refund Mode" : "Payment Method"}
                    </Typography>
                    <Typography
                      variant="p"
                      fontSize="14px"
                      fontWeight={700}
                      textAlign={right}
                      sx={{ color: "#219647" }}
                    >
                      {type == "returns" ? orderDetails?.returnMode : orderDetails?.paymentMethod}
                    </Typography>
                  </Box>
                </Box>

                <Box className="order-details-bill-second">
                  {branchSubType === "FINE_DINE" && (
                    <Box className="order-details-bill-no">
                      <Typography variant="p" fontSize="14px" fontWeight={600}>
                        Table Number :{" "}
                      </Typography>
                      <Typography variant="p" fontSize="14px" fontWeight={700}>
                        {orderData?.data?.baseOrderResponse?.tableNumber}
                      </Typography>
                    </Box>
                  )}
                  <Box className="order-details-bill-no">
                    <Typography variant="p" fontSize="14px" fontWeight={600}>
                      Source
                    </Typography>

                    {salesChannelInfo ? (
                      <Box display="flex" alignItems="center" gap={1}>
                        {salesChannelInfo.logo && (
                          <img
                            src={salesChannelInfo.logo}
                            alt={salesChannelInfo.label}
                            style={{ width: 18, height: 18 }}
                          />
                        )}
                        <Typography
                          variant="body2"
                          fontSize="14px"
                          fontWeight={700}
                          sx={{ color: salesChannelInfo.color }}
                        >
                          {salesChannelInfo.label}
                        </Typography>
                      </Box>
                    ) : (
                      <Typography variant="body2" fontSize="14px" fontWeight={700}>
                        -
                      </Typography>
                    )}
                  </Box>
                </Box>

                <Box class="orderDetailsBasicDetails">
                  <Typography variant="p" fontSize={"14px"} fontWeight={700}>
                    Basic Details
                  </Typography>
                  <Box className="orderDetailsBasicDetailsInner">
                    <Box className="orderDetailsBasicDetailsInnerText">
                      <Typography variant="p">Customer Name</Typography>
                      <Typography variant="p">
                        {type === "returns"
                          ? orderData?.data?.baseReturnResponse?.customerName || "NA"
                          : orderData?.data?.baseOrderResponse?.customerName || "NA"}
                      </Typography>
                    </Box>
                    <Box className="orderDetailsBasicDetailsInnerText">
                      <Typography variant="p">Customer Number</Typography>
                      <Typography variant="p">
                        {type === "returns"
                          ? orderData?.data?.baseReturnResponse?.mobileNumber || "NA"
                          : orderData?.data?.baseOrderResponse?.mobileNumber || "NA"}
                        {}
                      </Typography>
                    </Box>
                    {baseDetails?.pricingMode && (
                      <Box className="orderDetailsBasicDetailsInnerText">
                        <Typography variant="p">Pricing Mode</Typography>
                        <Typography
                          variant="p"
                          fontWeight={700}
                          sx={{
                            color: baseDetails.pricingMode === "WHOLESALE" ? "#92400e" : "#166534",
                          }}
                        >
                          {baseDetails.pricingMode === "WHOLESALE" ? "Wholesale" : "Retail"}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                </Box>
                <Box my={2} sx={{ textAlign: "center" }}>
                  <Typography variant="p" className="order-details-divider">
                    {type === "returns" ? "CREDIT NOTE" : "TAX INVOICE"}
                  </Typography>
                </Box>
                <Box>
                  <table className="order-inner-table">
                    <thead>
                      <tr>
                        <th>HSN</th>
                        <th>Particulars</th>
                        <th>Qty</th>
                        <th>Rate</th>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      {gstSlabData?.map(
                        (slab, index) =>
                          slab?.item?.length !== 0 && (
                            <GstSlabs
                              key={index}
                              title={slab?.title}
                              items={slab?.item}
                              type={type}
                            />
                          )
                      )}
                      {orderData?.data?.orderBillingDetails?.deliveryCharges > 0 && (
                        <tr>
                          <td colSpan="2" style={{ fontWeight: 700 }}>
                            Delivery Charges
                          </td>
                          <td></td>
                          <td colSpan="2" style={{ fontWeight: 700 }}>
                            ₹ {orderData?.data?.orderBillingDetails?.deliveryCharges}
                          </td>
                        </tr>
                      )}
                      {orderData?.data?.orderBillingDetails?.couponValue > 0 && (
                        <tr>
                          <td colSpan="2" style={{ fontWeight: 700 }}>
                            Coupon
                          </td>
                          <td></td>
                          <td colSpan="2" style={{ fontWeight: 700 }}>
                            ₹ {orderData?.data?.orderBillingDetails?.couponValue}
                          </td>
                        </tr>
                      )}
                      {getAppliedOrderDiscount(orderData?.data?.orderBillingDetails) > 0 && (
                        <tr>
                          <td colSpan="2" style={{ fontWeight: 700 }}>
                            Discount
                          </td>
                          <td></td>
                          <td colSpan="2" style={{ fontWeight: 700 }}>
                            ₹ {getAppliedOrderDiscount(orderData?.data?.orderBillingDetails)}
                          </td>
                        </tr>
                      )}
                      {getTotalDiscount(orderData?.data?.orderBillingDetails) > 0 && (
                        <tr>
                          <td colSpan="2" style={{ fontWeight: 700 }}>
                            Total Discount
                          </td>
                          <td></td>
                          <td colSpan="2" style={{ fontWeight: 700 }}>
                            ₹ {getTotalDiscount(orderData?.data?.orderBillingDetails)}
                          </td>
                        </tr>
                      )}
                      {orderData?.data?.orderBillingDetails?.packingCharges > 0 && (
                        <tr>
                          <td colSpan="2" style={{ fontWeight: 700 }}>
                            Packing Charges
                          </td>
                          <td></td>
                          <td colSpan="2" style={{ fontWeight: 700 }}>
                            ₹ {orderData?.data?.orderBillingDetails?.packingCharges}
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td colSpan="2" style={{ fontWeight: 700 }}>
                          Grand Total
                        </td>
                        <td colSpan="1" style={{ fontWeight: 700 }}>
                          {totalQuantity}
                        </td>
                        <td colSpan="2" style={{ fontWeight: 700 }}>
                          ₹{" "}
                          {type === "returns"
                            ? orderDetails?.returnAmount
                            : orderDetails?.grandTotal}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <Box>
                    <Box my={2} sx={{ textAlign: "center" }}>
                      <Typography variant="p" className="order-details-divider">
                        GST Breakup Details
                      </Typography>
                    </Box>
                    <Box>
                      <table className="order-inner-table">
                        <thead>
                          {" "}
                          <tr>
                            <th>GST IND</th>
                            <th>Taxable Amount</th>
                            <th>CGST</th>
                            <th>SGST</th>
                            <th>Cess</th>
                            <th>Total Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {gstBreakupDetails?.length !== 0 &&
                            gstBreakupDetails
                              ?.filter((item) => item.taxableAmt != null)
                              .map((e, i) => (
                                <tr key={i}>
                                  <td>{i + 1}</td>
                                  <td>{e.taxableAmt.toFixed(2)}</td>
                                  <td>{e.cgst.toFixed(2)}</td>
                                  <td>{e.sgst.toFixed(2)}</td>
                                  <td>{e.cess ? e.cess : "---"}</td>
                                  <td>{e.totalAmt}</td>
                                </tr>
                              ))}
                        </tbody>
                      </table>
                    </Box>

                    {!!returnDetails?.returnedItems && (
                      <Box>
                        <Box my={2} sx={{ textAlign: "center" }}>
                          <Typography variant="p" className="order-details-divider">
                            RETURN
                          </Typography>
                        </Box>{" "}
                        <table className="order-inner-table">
                          <thead>
                            <tr>
                              <th>HSN</th>
                              <th>Particulars</th>
                              <th>Returned Qty</th>
                              <th>Rate</th>
                              <th>Value</th>
                            </tr>
                          </thead>
                          <tbody>
                            {returnDetails?.returnedItems?.map((e, i) => (
                              <tr key={i}>
                                <td className="order-item-list-box">
                                  {e?.hsnCode?.substring(0, 4) || "N/A"}
                                </td>
                                <td className="order-item-list-box">{e?.productName}</td>
                                <td className="order-item-list-box">{e?.quantityBySpecs}</td>
                                <td className="order-item-list-box">₹ {e?.sellingPrice}</td>
                                <td className="order-item-list-box">
                                  ₹ {Number(e.quantityBySpecs) * Number(e.sellingPrice)}
                                </td>
                              </tr>
                            ))}

                            <tr>
                              <td colSpan="2">Total</td>
                              <td colSpan="1"></td>
                              <td colSpan="2">₹ {returnDetails?.refundAmount}</td>
                            </tr>
                          </tbody>
                        </table>
                      </Box>
                    )}

                    <Box my={2} sx={{ textAlign: "center" }}>
                      <Typography variant="p" className="order-details-divider">
                        {type === "returns" ? "Return Refund Details" : "Payment Breakup Details"}
                      </Typography>
                    </Box>
                    {(type === "returns" ? returnPaymnetBreakupDetails : paymnetBreakupDetails)
                      ?.length === 0 ? (
                      <div className="payment-not-done-wrapper">
                        <h5>No payment details found</h5>
                      </div>
                    ) : (
                      <Box>
                        <table className="order-inner-table">
                          <thead>
                            {type === "returns" ? (
                              <tr>
                                <th>Created Time</th>
                                <th>Return Amount</th>
                                <th>Payment Mode</th>
                                <th>Return Status</th>
                              </tr>
                            ) : (
                              <tr>
                                <th>Amount Paid</th>
                                <th>Payment Method</th>
                                <th>Payment Mode</th>
                                <th>Payment Status</th>
                              </tr>
                            )}
                          </thead>
                          <tbody>
                            {(type === "returns"
                              ? returnPaymnetBreakupDetails?.refunds
                              : paymnetBreakupDetails
                            )?.map((e, i) => (
                              <>
                                {type === "returns" ? (
                                  <tr key={i}>
                                    <td>{convertToLocalDateTime(e.createdDate)}</td>
                                    <td>₹ {e?.refundAmount}</td>
                                    <td>{e?.refundMode}</td>
                                    <td className="paid-text-order">
                                      {e?.status === "COMPLETED" ? "REFUND COMPLETE" : "----"}
                                    </td>
                                  </tr>
                                ) : (
                                  <tr key={i}>
                                    <td>₹ {e?.amountPaid}</td>
                                    <td>{e?.paymentMethod}</td>
                                    <td>{e?.paymentMode}</td>
                                    <td className="paid-text-order">
                                      {e?.paymentStatus === "COMPLETED" ? "PAID" : "----"}
                                    </td>
                                  </tr>
                                )}
                              </>
                            ))}
                          </tbody>
                        </table>
                      </Box>
                    )}
                    <Box my={2} sx={{ textAlign: "center" }}>
                      <Typography variant="p" className="order-details-divider">
                        Loyalty Information
                      </Typography>
                    </Box>
                    {!loyaltyData ? (
                      <div className="payment-not-done-wrapper">
                        <h5>No Loyalty details available...</h5>
                      </div>
                    ) : (
                      <>
                        <div className="customer-inner-wrapper-middle">
                          <h5 className="order-details-divider">Loyalty for this order</h5>
                          <Box className="customer-details-bill-details-order" mt={1}>
                            <div className="cutomer-details-bill-no">
                              <p>Earned Points: </p>
                              <p className="cutomer-details-bill-no-text">
                                {orderDetails?.earnedPoints || 0}({`\u20b9`}{" "}
                                {orderDetails?.earnedPointValue || 0})
                              </p>
                            </div>
                            <div className="cutomer-details-bill-no">
                              <p>Used Points: </p>
                              <p className="cutomer-details-bill-no-text">
                                {orderDetails?.loyaltyPoints || 0}({`\u20b9`}{" "}
                                {orderDetails?.loyaltyPointsValue || 0})
                              </p>
                            </div>
                          </Box>
                        </div>

                        <div className="customer-inner-wrapper-middle">
                          <h5 className="order-details-divider">Current Loyalty Balance</h5>
                          <Box className="customer-details-bill-details-order" mt={1}>
                            <Box className="cutomer-details-bill-no">
                              <div>Available Points: </div>
                              <div className="cutomer-details-bill-no-text">
                                {loyaltyData?.totalAvailablePointValue || 0}({`\u20b9`}{" "}
                                {loyaltyData?.totalAvailablePoint || 0})
                              </div>
                            </Box>
                            <Box className="cutomer-details-bill-no">
                              <div>Total Redeemed Points: </div>
                              <div className="cutomer-details-bill-no-text">
                                {loyaltyData?.totalRedeemedPoint || 0}({`\u20b9`}{" "}
                                {loyaltyData?.totalRedeemedPointValue || 0})
                              </div>
                            </Box>
                            <Box className="cutomer-details-bill-no">
                              <div>Total Points Earned : </div>
                              <div className="cutomer-details-bill-no-text">
                                {loyaltyData?.totalEarnedPoint || 0}({`\u20b9`}{" "}
                                {loyaltyData?.totalEarnedPointValue || 0})
                              </div>
                            </Box>
                            <Box className="cutomer-details-bill-no">
                              <div>Expired Points: </div>
                              <div className="cutomer-details-bill-no-text">
                                {loyaltyData?.totalExpiredPoint || 0}({`\u20b9`}{" "}
                                {loyaltyData?.totalExpiredPointValue || 0})
                              </div>
                            </Box>
                          </Box>
                        </div>
                      </>
                    )}
                  </Box>
                </Box>
              </Box>
            )}
            {billTabValue === "1" && (
              <div class="center bill-preview">
                <OrderDetailsNew orderId={orderId} />
              </div>
            )}
          </div>
        )}
      </Box>

      {/* Manager PIN gate — shown to non-managers before the payment modal opens */}
      <ManagerPinVerifyModal
        open={showManagerPinGate}
        onClose={() => {
          setShowManagerPinGate(false);
          resetPaymentValues();
        }}
        onSuccess={() => {
          setShowManagerPinGate(false);
          setForceOfflineMode(true);
          setOpenPayModal(true);
        }}
        title="Authorise Offline Payment"
      />

      {/* Payment Modal */}
      <PaymentModal
        openPayModal={openPayModal}
        closePaymentModal={closePaymentModal}
        cartItems={baseDetails?.orderItemList || [{ id: 1 }]}
        forceOfflinePay={forceOfflineMode}
        newLoader={false}
        modalLoader={modalLoader}
        payLoader={payLoader}
        partialStatus={partialStatus}
        paymentMethod={paymentMethod}
        splitActive={splitActive}
        setSplitActive={setSplitActive}
        amtHeading="Amount Due"
        amountDue={amountDue}
        adjustCheck={false}
        amtToBePaid={amountDue}
        setPaymentMethod={setPaymentMethod}
        cashIcon={cashNew}
        cashIconSelected={cashNewSelected}
        upiIcon={upiNew}
        upiIconSelected={upiNewSelected}
        cardIcon={cardNew}
        cardIconSelected={cardNewSelected}
        creditIcon={creditNew}
        creditIconSelected={creditNewSelected}
        storeMode={storeMode}
        handleOffline={handleOffline}
        singleOrderoffline={singleOrderoffline}
        offlineImg={offlineImg}
        splitImg={splitNew}
        splitImgSelected={splitNewSelected}
        handleSplitPayment={handleSplitPayment}
        checkPayment={partialCompletePayment}
        clrAmountFun={clrAmountFun}
        enterAmount={enterAmount}
        setEnterAmount={setEnterAmount}
        enterAmountRef={null}
        cashChange={cashChange}
        handlesplitInputChange={handlesplitInputChange}
        amountPaid={amountPaid}
        functionCalled={functionCalled}
        setFunctionCalled={setFunctionCalled}
        cardFunctionCalled={cardFunctionCalled}
        setCardFunctionCalled={setCardFunctionCalled}
        setSplitFunctionCalled={setSplitFunctionCalled}
        splitFunctionCalled={splitFunctionCalled}
        paymentLoader={paymentLoader}
        paymentLoadingModal={paymentLoadingModal}
        manual={manual}
        transCode={transCode}
        approveloader={approveloader}
        cashierPin={null}
        paymentFailed={paymentFailed}
        newId={orderId}
        failedImgWarning={failedImgWarning}
        handleTansactionCancel={() => {}}
        cancelLoader={cancelLoader}
        paymentSuccess={paymentSuccess}
        isError={false}
        isPrinting={false}
        orderId={orderId}
        resetValues={resetPaymentValues}
        paymentCancel={paymentCancel}
        cancelGif={cancelGif}
        handleManual={handleManual}
        newTransId={newTransId}
        setPaymentSuccess={setPaymentSuccess}
        setpaymentLoader={setpaymentLoader}
        partialCompletePayment={partialCompletePayment}
        total={amountDue}
        setOpen={() => {}}
      />
    </>
  );
};
